module.exports = __webpack_public_path__ + "static/media/instagram_white.50615bc5.svg";